export default {
  images: (state) => {
    return state.images
  },

  gallery: (state) => {
    return state.current_gallery
  }
}
